import * as Type from './types'

export function populate(data, callback = {success: null, error: null}) {
    return {
        type: Type.POPULATE,
        data: data,
        callback: callback
    }
}

export function setFormat(data, format = Type.SET_FORMAT, callback = null)
{
    return {
        type: format,
        data: data,
        callback: callback
    }
}

export function setLoaded(value = null, callback = null) {
    return {
        type: Type.SET_LOADED,
        data: value,
        callback: callback
    }
}